<h1 mat-dialog-title class="text-center">{{ 'Intellitrailer.Rental.Dialog.confirmObject.lblHeadline' | translate : 'Confirm vehicle'}}</h1>
<div mat-dialog-content>
  @if(this.data.object) {
  <p class="text-center">{{ this.data.object?.Title }}</p>
  }
  <p class="text-center">{{ 'Intellitrailer.Rental.confirmObject.TextReturn' | translate : 'Please, confirm that you are trying to pickup the correct vehicle.'}}</p>
</div>
<div class="btn-container" mat-dialog-actions>
  <button mat-button mat-raised-button color="accent" (click)="cancel()">{{ 'Intellitrailer.Rental.Dialog.confirmObject.cmdCancel' | translate : 'Cancel'}}</button>
  <button mat-button mat-raised-button color="primary" (click)="confirm()">{{ 'Intellitrailer.Rental.Dialog.confirmObject.cmdConfirm' | translate : 'Confirm'}}</button> 
</div>
